var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import moment from 'moment';
import { Type, Transform, Expose } from 'class-transformer';
import { ApiTokenScope } from '@logz-pkg/enums';
export const humanReadableApiTokenScopes = {
    [ApiTokenScope.Admin]: 'Admin',
    [ApiTokenScope.Regular]: 'User',
    [ApiTokenScope.ReadOnly]: 'Read-only',
    [ApiTokenScope.Custom]: 'Custom',
};
export class ApiTokenModel {
    id;
    token;
    name = '';
    createdAt;
    lastUsed;
    role;
}
__decorate([
    Expose({ name: 'tokenName', toPlainOnly: true }),
    __metadata("design:type", Object)
], ApiTokenModel.prototype, "name", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    __metadata("design:type", Object)
], ApiTokenModel.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Number)
], ApiTokenModel.prototype, "lastUsed", void 0);
//# sourceMappingURL=api-token.js.map